import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {maxHeight} from "styled-system";
import {Block, Tabs} from "reakit";
import {Box, Card, Flex, Text} from "rebass";
import {HorizontalScroll, TabHeader} from "../Base";
import {schoolSelectors} from "../../store/school";
import {authSelectors} from "../../store/auth";
// import {searchActions, searchSelectors} from "../../store/search";
import styled from "styled-components";
import SelectInput from '../Forms/SelectInput'
import {DatePicker} from "../Forms";
import {leaveUtils} from "../../utils";
// import styled from "styled-components";
import {ACTOR_OPTIONS} from "../AirportTab/constants";

/* icon imports */
const PanelWrapper = styled(Card)`
//min-width: 250px;
//	height: calc(100vh - 131px);
//	margin-bottom: 10px;
	max-height: calc(45vh - 65px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(max-width: 700px){
  //	height: 70vh;
  //
  //}
  ${maxHeight}
`;

PanelWrapper.defaultProps = {
	maxHeight: ['calc(100vh - 145px)', 'calc(45vh - 65px)']
};

class LeaveFilters extends Component {
	state = {
		filters: {
			students: [],
			actors: [],
			type: [],
			leaveBy: [],
			returnBy: [],
			leaveAt: null,
			returnAt: null
		},
		selectAll: {
			students: false,
			actors: false,
			type: false,
			leaveBy: false,
			returnBy: false,
			leaveAt: false,
			returnAt: false

		}
	}

	handleSelect = (name, index) => {
		const {filters} = this.props;
		let newFilters = filters;
		let filter = filters[index];
		// console.log('filter', filter);
		let contains = false;
		for (var i = filter.length - 1; i >= 0; i--) {
			if (filter[i] === name) {
				filter.splice(i, 1);
				contains = true;

				newFilters[index] = filter

			}
		}

		if (!contains) {
			filter.push(name);
			newFilters[index] = filter
		}

		this.handleUpdateFilters(newFilters)


	};

	handleUpdateDateFilter = (date, name) => {
		const {filters} = this.props;
		let newFilters = filters;
		newFilters[name] = date;

		this.handleUpdateFilters(newFilters)
	}

	handleUpdateFilters = (filters) => {
		const {handleUpdate, isCheckin, handleCheckinUpdate} = this.props;
		if (isCheckin) {
			handleCheckinUpdate(filters)
		} else {
			handleUpdate(filters)

		}
		this.setState({filters})
	}

	handleSelectAll = (all, index) => {
		const { isCheckin, checkinFilters} = this.props;
		const {selectAll, filters} = this.state
		// new state starts here
		let newFilters = filters;
		let newSelectAll = selectAll

		let filter = filters[index];
		// console.log('filter', filter);
		if (all.length === filter.length || selectAll[index] === true) {
			filter = []
			newSelectAll[index] = false

		} else {
			if (isCheckin === true) {
				const lockedFilter = checkinFilters[index]
				filter = all.filter(val => !lockedFilter.includes(val))
				newSelectAll[index] = true
			} else {
				filter = all
				newSelectAll[index] = true

			}
		}

		this.setState({selectAll: newSelectAll})
		newFilters[index] = filter
		this.handleUpdateFilters(newFilters)
	}

	renderSelectAll = (all, index) => {
		const {selectAll} = this.state;
		const selected = selectAll[index]
		return (
			<Box width={1}>
				<Flex justifyContent={'flex-start'} flexWrap={'wrap'} pt={2} pb={3}>
					<Text ml={3} color='blue'
					      onClick={() => this.handleSelectAll(all, index)}>{selected ? 'Unselect All' : 'Select All'}</Text>
				</Flex>
			</Box>
		)
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.filters !== this.props.filters) {
			this.setState({filters: nextProps.filters})
		}
	}

	render() {
		const {filters, schoolInfo, isLoading} = this.props;

		let options = {
			leaveTypes: [],
			transportTypes: []
		}

		if (!isLoading) {
			options = leaveUtils.reduceSchoolToLeaveOptions(schoolInfo)
		}
		return (
			<div>
				<Tabs.Container>

					{tabs => (
						<Block maxHeight={'45vh'} fontWeight={600}>
								<Tabs width={'100%'}>
									<HorizontalScroll pl={3}>

									<Tabs.Tab padding={'15px'} minWidth={'90px'} tab="type" {...tabs}><TabHeader title={'Leave Type'}/></Tabs.Tab>
									<Tabs.Tab padding={'15px'} minWidth={'90px'} tab="leaveBy" {...tabs}><TabHeader title={'Leave By'}/></Tabs.Tab>
									<Tabs.Tab padding={'15px'} minWidth={'90px'} tab="returnBy" {...tabs}><TabHeader title={'Return By'}/></Tabs.Tab>
									<Tabs.Tab padding={'15px'} minWidth={'90px'} tab="leaveAt" {...tabs}><TabHeader title={'Leave At'}/></Tabs.Tab>
									<Tabs.Tab padding={'15px'} minWidth={'90px'} tab="returnAt" {...tabs}><TabHeader title={'Return At'}/></Tabs.Tab>
									<Tabs.Tab padding={'15px'} minWidth={'80px'} tab="actors" {...tabs}><TabHeader title={'Actors'}/></Tabs.Tab>									</HorizontalScroll>


								</Tabs>
							{!isLoading &&
							<Fragment>
								<Tabs.Panel tab="type" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>
										{options.leaveTypes.map(option =>
											<SelectInput key={option.value} type={'type'} label={option.label} value={option.value} selected={filters.type.includes(option.value)}  onChange={this.handleSelect}/>
										)}

									</PanelWrapper>
								</Tabs.Panel>
								<Tabs.Panel tab="leaveBy" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>


										{/*{this.renderSelectAll(['3', '4', '5', '6'], 'grade')}*/}
										{options.transportTypes.map(option =>
											<SelectInput key={option.value} type={'leaveBy'} label={option.label} value={option.value} selected={filters.leaveBy.includes(option.value)}  onChange={this.handleSelect}/>
										)}

									</PanelWrapper>
								</Tabs.Panel>
								<Tabs.Panel tab="returnBy" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>
										{options.transportTypes.map(option =>
											<SelectInput key={option.value} type={'returnBy'} label={option.label} value={option.value} selected={filters.returnBy.includes(option.value)}  onChange={this.handleSelect}/>
										)}

									</PanelWrapper>
								</Tabs.Panel>
								<Tabs.Panel tab="leaveAt" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>
										<Flex justifyContent={'center'}>

											<DatePicker handleChange={this.handleUpdateDateFilter} name={'leaveAt'}/>
										</Flex>
									</PanelWrapper>
								</Tabs.Panel>

								<Tabs.Panel tab="returnAt" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>
										{/*{this.renderSelectAll(['D', 'B'], 'type')}*/}

										<Flex justifyContent={'center'}>
										<DatePicker handleChange={this.handleUpdateDateFilter} name={'returnAt'}/>

										</Flex>

									</PanelWrapper>
								</Tabs.Panel>
								<Tabs.Panel tab="actors" {...tabs}>
									<PanelWrapper mt={'15px'} px={2}>
										{/*{this.renderSelectAll(['D', 'B'], 'type')}*/}

										{ACTOR_OPTIONS.map(option => (
											<SelectInput key={option.value} type={'actors'} label={option.label} value={option.value} selected={filters.actors.includes(option.value)}  onChange={this.handleSelect}/>

										))}

									</PanelWrapper>
								</Tabs.Panel>
							</Fragment>}

						</Block>
					)}
				</Tabs.Container>
			</div>
		);
	}
}


LeaveFilters.propTypes = {
	filters: PropTypes.object,
	handleUpdate: PropTypes.func
};

LeaveFilters.defaultProps = {

	filters: {
		students: [],
		actors: [],
		type: [],
		leaveBy: [],
		returnBy: [],
		leaveAt: null,
		returnAt: null
	},
	handleUpdate: (filters) => console.log('filters handleUpdate', filters)
};


const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loading: authSelectors.isLoading(state.auth),
	isLoading: schoolSelectors.isLoading(state.school)
});
;

export default connect(
	mapStateToProps
)(LeaveFilters);
